function SegmentsFormController(stateService, CommonService, toasterService, $uibModal, $timeout) {
  const ctrl = this;
  const preLoadAudio = CommonService.preLoadAudio;
  const checkName = CommonService.checkName;

  ctrl.$onInit = () => {
    ctrl.streamTypes = stateService.getStreamTypes();
    if (!ctrl.selection) {
      ctrl.segment = {
        name: null,
        description: null,
        stream_type: null,
        simulator_script: false
      };
      ctrl.newSegment = true;
      ctrl.viewMode = false;
    } else {
      ctrl.segment = angular.copy(ctrl.selection);
      ctrl.viewMode = true;
      ctrl.filteredFiles = preLoadAudio(ctrl.segment);
      ctrl.fileModel = {};
      ctrl.fileModel.file = '';
      ctrl.audioSegmentEdit = isAudioSegmentEdit();
    }
    // Actor parameter is currently unused, but needs to be -1
    ctrl.segment['actor'] = -1;
  };

  ctrl.$onChanges = changes => {
    if (changes.selection && ctrl.viewMode) {
      ctrl.segment = angular.copy(ctrl.selection);
      ctrl.filteredFiles = preLoadAudio(ctrl.segment);
    }
  };

  const isAudioSegmentEdit = () => {
    return !ctrl.newSegment && ctrl.segment.stream_type === 'AUDIO';
  };

  ctrl.checkValidity = () => {
    return ctrl.segment.name.length === 0 || ctrl.duplicateName;
  };

  ctrl.toggleEditMode = value => {
    if (value) {
      ctrl.viewMode = false;
    } else {
      ctrl.segment = angular.copy(ctrl.selection);
      ctrl.viewMode = true;
    }
  };

  ctrl.checkDuplicate = () => {
    ctrl.duplicateName = checkName(ctrl.segments, ctrl.segment);
  };

  ctrl.fileSelected = (event, files) => {
    if (!files || files.length === 0) return;
    let file = files[0];
    ctrl.fileModel.file = file;
    ctrl.openUploadModal();
  };

  ctrl.openUploadModal = function () {
    const modalInstance = $uibModal.open({
      component: 'fileUploadModal',
      resolve: {
        file: function () {
          return ctrl.fileModel.file;
        },
      },
    });

    modalInstance.result
      // User pressed 'Accept'
      .then(type => {
        stateService.uploadAudio(ctrl.segment.id, type, ctrl.fileModel.file).then((response) => {
          ctrl.onFileUpload({
            $event: {
              current: ctrl.segment,
            },
          });
          if (response.statusCode !== 422 && response.statusCode !== 500) {
            toasterService.success('toaster.pis-event', 'toaster.pis-segment-fileupload-successful');
          } else {
            toasterService.error('toaster.pis-segment-fileupload-failure', 'toaster.pis-segment-fileupload-failure');
          }
        });
      });
  };

  ctrl.clearForm = () => {
    if (ctrl.segmentForm) {
      ctrl.segmentForm.$setPristine(true);
      ctrl.segmentForm.$setUntouched(true);
    }
    ctrl.viewMode = false;
    ctrl.duplicateName = false;
    ctrl.segment = {
      name: null,
      description: null,
      stream_type: null,
      simulator_script: false
    };
  };

  ctrl.onSubmit = () => {
    if (ctrl.newSegment) {
      stateService.createSegment(ctrl.segment).then(
        function (response) {
          ctrl.onFormSubmit({
            $event: {
              mode: false,
            },
          });
          if (response.statusCode !== 404 && response.statusCode !== 500) {
            toasterService.success('toaster.pis-event', 'toaster.pis-new-segment-successful');
          } else {
            toasterService.error('toaster.pis-event', 'toaster.pis-new-segment-failure');
          }
        },
        function (e) {
          toasterService.error('toaster.pis-event', 'toaster.pis-new-segment-failure');
          console.log(e);
        }
      );
    } else {
      // EDIT
      stateService.editSegment(ctrl.segment.id, ctrl.segment).then(
        function (response) {
          ctrl.onFormSubmit({
            $event: {
              mode: false,
            },
          });
          if (response.statusCode !== 404 && response.statusCode !== 500) {
            toasterService.success('toaster.pis-event', 'toaster.pis-edit-segment-successful');
          } else {
            toasterService.error('toaster.pis-event', 'toaster.pis-edit-segment-failure');
          }
        },
        function (e) {
          // toasterService.error('toaster.package-upload-event', 'toaster.package-upload-start-failure');
          console.log(e);
        }
      );
    }
  };
}

angular
  .module('segments.module')
  .controller('SegmentsFormController', SegmentsFormController);
